import React, { useRef } from 'react';
import { cn } from 'cn';
import { TabsContent } from '@/components/ui/tabs';

type TabProps = {
  /** Título da aba no cabeçalho (lido pelo `Tabs`). */
  label?: React.ReactNode;
  /** Contador ao lado do título; 0 ou vazio não aparece (lido pelo `Tabs`). */
  badgeCount?: number;
  /** Classes do título da aba no cabeçalho (lido pelo `Tabs`). `d-none` esconde a aba. */
  navItemClass?: string;
  /** Preenchido pelo `Tabs`; a tela não passa. */
  active?: boolean;
  /** Preenchido pelo `Tabs`; a tela não passa. */
  value?: string;
  /** Conteúdo da aba. Só monta na primeira vez que a aba abre e depois fica montado. */
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * Uma aba do `Tabs`. Sempre filho direto do `Tabs`.
 * @import import Tab from 'src/componentes/tabs/tab';
 */
export default function Tab({
  active,
  value,
  children,
  className,
  style,
}: TabProps) {
  const rendered = useRef(false);

  if (!active && !rendered.current) {
    return null;
  }

  rendered.current = true;

  return (
    <TabsContent
      value={value as string}
      forceMount
      hidden={!active}
      tabIndex={undefined}
      className={cn('tab-pane', active && 'active', className)}
      style={style}
    >
      {children}
    </TabsContent>
  );
}
